import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'

const LINES = ['Line 1', 'Line 2', 'Line 3', 'Line 4']
const MONTHS = [
  'Apr 2026', 'May 2026', 'Jun 2026', 'Jul 2026',
  'Aug 2026', 'Sep 2026', 'Oct 2026', 'Nov 2026',
  'Dec 2026', 'Jan 2027', 'Feb 2027', 'Mar 2027',
]

export default function MaintenanceDialog({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    line: '',
    month: '',
    hours: '',
    description: '',
  })

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }))
  }

  const handleSave = () => {
    onSave?.({
      ...form,
      hours: Number(form.hours),
    })
    setForm({ line: '', month: '', hours: '', description: '' })
    onClose()
  }

  const isValid = form.line && form.month && form.hours && Number(form.hours) > 0

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Maintenance Window</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel>Production Line</InputLabel>
          <Select value={form.line} label="Production Line" onChange={handleChange('line')}>
            {LINES.map((l) => (
              <MenuItem key={l} value={l}>{l}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Month</InputLabel>
          <Select value={form.month} label="Month" onChange={handleChange('month')}>
            {MONTHS.map((m) => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Maintenance Hours"
          type="number"
          value={form.hours}
          onChange={handleChange('hours')}
          inputProps={{ min: 0, step: 1 }}
          fullWidth
        />

        <TextField
          label="Description"
          value={form.description}
          onChange={handleChange('description')}
          multiline
          rows={2}
          fullWidth
          placeholder="e.g., Annual line overhaul, deep clean..."
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!isValid}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  )
}
